import { Component, OnInit } from '@angular/core';

import { Utility } from '../../../common/utility';
import { AppMessages } from '../../../shared/constants/messages';
import { AppConstants } from '../../../shared/constants/constants';
import { Page } from '../../../models/list/page.model';
import { BaseService } from '../../../shared/services/base.service';
import { DialogService } from '../../../shared/services/dialog.service';

import { LabTestDataService } from './lab-test-data.service';
import { LabTestDataModel } from '../../../models/master-data/lab-test-data.model';
import { ModifyLabTestDataComponent } from './modify-lab-test-data-popup.component';
import { LabTestCategoryModel } from '../../../models/master-data/labtest-category.model';
import { TMBDataTableComponent } from '../../../components/data-table/data-table.component';
import { SharedService } from '../../../shared/services/share.services';

@Component({
    selector: 'lab-test-data',
    templateUrl: 'lab-test-data.component.html',
    providers: [LabTestDataService]
})

export class LabTestDataComponent extends TMBDataTableComponent implements OnInit {
    dataRow = new Array<LabTestDataModel>();
    public filterData = { labTestCategoryId: null, labTestName: '' };
    public screenData = [];

    labTestCategories = new Array<LabTestCategoryModel>();

    constructor(
        public dialogService: DialogService,
        public utility: Utility,
        public sharedService: SharedService,
        private labTestDataService: LabTestDataService) {
          super(sharedService);
        }

    ngOnInit() {
        this.labTestDataService.getLabTestCategory().subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.labTestCategories = data;

                    // set default filter is first element list
                    if (this.labTestCategories.length) {
                        this.filterData.labTestCategoryId = this.labTestCategories[0].id;
                        this.setPage({ offset: 0 });
                    }
                }
            }
        );
        this.labTestDataService.getScreenData().subscribe(
            result => {
                if (result) {
                    const data = result.json();
                    this.screenData = data['list'];
                }
            }
        );
    }

    setPage(pageInfo) {

        this.page.pageNumber = pageInfo.offset;
        const param = {
            selectedCategory: this.filterData.labTestCategoryId === 'null' ? '' : this.filterData.labTestCategoryId,
            pageSize: this.page.size,
            currentPage: this.page.pageNumber + 1,
            labTestName: this.filterData.labTestName
        };

        this.labTestDataService.getLabTestBycategory(param).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.dataRow = data['list'];
                    this.page.pageNumber = pageInfo.offset;
                    this.page.totalElements = data['totalRecords'];
                }
            },
            error => { }
        );
    }

    onFilter() {
        this.setPage({ offset: 0 });
    }

    onEditItem(id) {
        this.dialogService.openComponentDialog(ModifyLabTestDataComponent,
            { id: id }).subscribe(
            (result) => {
                if (result) {
                  this.reloadPage(this.page.pageNumber, this.dataRow);
                }
            }
            );
    }

    addNewLabTest() {
      const categoryName = this.labTestCategories.find(item => item.id === this.filterData.labTestCategoryId).name;
      const data = {
        categoryId: this.filterData.labTestCategoryId,
        categoryName: categoryName ? categoryName : ''
      };

      this.dialogService.openComponentDialog(ModifyLabTestDataComponent, data).subscribe(
        (result) => {
            if (result) {
              this.reloadPage(this.page.pageNumber, this.dataRow);
            }
        }
      );
    }

    onRemoveItem(id) {
        this.dialogService.openConfirmationDialog({ message: AppMessages.labTest.removeLabTest }).subscribe(
            (result) => {
                if (result) {
                    this.labTestDataService.removeLabTest(id).subscribe(
                      (resultTemp) => {
                        if (resultTemp) {
                          this.reloadPage(this.page.pageNumber, this.dataRow, true);
                        }
                      }
                    );
                }
            }
        );
    }

    onLabTestCategoryChange() {
        this.filterData.labTestName = '';
        this.setPage({ offset: 0 });
    }
}




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/lab-test-data/lab-test-data.component.ts